import axios from "axios";
import {API_URL} from "@env";

export const setProgram = (code, type, memberId) => {
    return axios.get(API_URL + `/packages/check-program-code/${code}/${type}/${memberId}`);
}

export const getProgram = (type, memberId) => {
    return axios.get(API_URL + `/packages/get-program/${type}/${memberId}`);
}